import { render } from "./Three2Charts.vue?vue&type=template&id=6a49f7da&scoped=true"
import script from "./Three2Charts.vue?vue&type=script&lang=js"
export * from "./Three2Charts.vue?vue&type=script&lang=js"

import "./Three2Charts.vue?vue&type=style&index=0&id=6a49f7da&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a49f7da"]])

export default __exports__